//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Footer from '@/components/Footer.vue'
import TopNav from '@/components/TopNav.vue'

import { SHORT_MONTH_DAY_FORMAT } from '@/lib/constants'

import { formatDueDate } from '@/lib/utils'
import { isUnlimited, isPaidPlan } from '@/lib/plans'

import { mapGetters, mapState } from 'vuex'

import inboxUnreadCounts from '@/graphql/queries/conversations/inboxUnreadCounts.gql'

let tourSteps = [
  {
    target: '[data-v-step="schedule"]',
    header: {
      title: 'Schedule Posts'
    },
    content:
      'Use the <strong>New Post</strong> button to schedule your posts from anywhere in Postpone.',
    params: {
      placement: 'right',
      enableScrolling: false
    }
  },
  {
    target: '[data-v-step="scheduled"]',
    header: {
      title: 'Scheduled'
    },
    content:
      'This is the <strong>Scheduled Posts</strong> page. All of your scheduled posts are displayed here.',
    params: {
      placement: 'right',
      enableScrolling: false
    }
  },
  {
    target: '[data-v-step="submissions"]',
    header: {
      title: 'History'
    },
    content:
      "After posts are submitted they'll appear under <strong>History</strong>. If posts fail to submit then they'll also be on this page.",
    params: {
      placement: 'right',
      highlight: true,
      enableScrolling: false
    }
  },
  {
    target: '[data-v-step="content-library"]',
    header: {
      title: 'Content Library'
    },
    content:
      'Use the <strong>Content Library</strong> to upload and reuse content. You can also edit images, add watermarks, organize content, and more.',
    params: {
      placement: 'right',
      highlight: true,
      enableScrolling: false
    }
  },
  {
    target: '[data-v-step="subreddit-manager"]',
    header: {
      title: 'Subreddit Manager'
    },
    content:
      'Use the <strong>Subreddit Manager</strong> to organize, label, and learn more about your favorite subreddits to submit posts to.',
    params: {
      placement: 'right',
      highlight: true,
      enableScrolling: false
    }
  },
  {
    target: '[data-v-step="analytics"]',
    header: {
      title: 'Analytics'
    },
    content:
      'Use <strong>Analytics</strong> to see how your posts are performing, which subreddits and content are most popular, and make better decisions for future posts.',
    params: {
      placement: 'right',
      highlight: true,
      enableScrolling: false
    }
  },
  {
    target: '[data-v-step="settings"]',
    header: {
      title: 'Settings'
    },
    content:
      'Change your account <strong>Settings</strong> here. You can change default post settings, configure notifications, and connect more social accounts.',
    params: {
      placement: 'right',
      highlight: true,
      enableScrolling: false
    }
  },
  {
    target: '[data-v-step="upgrade-account"]',
    header: {
      title: 'Postpone Plans'
    },
    content:
      "Check out <strong>Postpone's plans</strong> to schedule more posts, connect more accounts, and unlock powerful social media features.",
    params: {
      placement: 'bottom',
      highlight: true,
      enableScrolling: false
    }
  }
]

export default {
  name: 'Default',
  components: {
    'postpone-footer': Footer,
    'postpone-topnav': TopNav
  },
  head() {
    let links = []
    if (this.hasUnreadMessages) {
      links.push({
        rel: 'icon',
        type: 'image/png',
        sizes: 'any',
        href: '/img/icons/favicon-32x32-unread.png'
      })
    } else {
      links.push({
        rel: 'icon',
        type: 'image/png',
        sizes: 'any',
        href: '/img/icons/favicon-32x32.png'
      })
    }
    return { link: links }
  },
  data() {
    return {
      SHORT_MONTH_DAY_FORMAT,
      mobileNavOpen: false,
      inboxMenuOpen: false,
      postsMenuOpen: this.$prefs.expandPostsMenu,
      callbacks: {
        onStart: this.onStart,
        onStop: this.onStop,
        onSkip: this.onSkip,
        onFinish: this.onFinish
      }
    }
  },
  apollo: {
    inboxUnreadCounts: {
      query: inboxUnreadCounts,
      pollInterval: 5 * 60 * 1000,
      variables() {
        return {
          reloadInboxes: true
        }
      },
      skip() {
        return !this.isLoggedIn
      },
      result({ data }) {
        if (!data) {
          return
        }
        this.$store.commit(
          'totalUnreadCount',
          data.inboxUnreadCounts.totalUnreadCount
        )
      }
    }
  },
  methods: {
    formatDueDate,
    async handleLogoutClick() {
      await this.$store.dispatch('logout')
      this.$buefy.toast.open({
        message: 'Successfully logged out',
        type: 'is-info'
      })
      window.location.href = '/'
    },
    onStart() {
      this.$store.commit('startTour')
      this.$gtag.event('tutorial_begin')
    },
    onSkip() {
      this.$store.commit('finishTour')
      this.$router.push({ name: 'dashboard' })
    },
    onFinish() {
      this.$store.commit('finishTour')
      this.$gtag.event('tutorial_complete')
      this.$router.push({ name: 'dashboard' })
    },
    onStop() {
      this.$store.commit('finishTour')
      this.$router.push({ name: 'dashboard' })
    },
    collapseNav() {
      this.mobileNavOpen = false
    },
    togglePostsMenuOpen() {
      if (this.postsMenuOpen) {
        // We want to remember that the user collapsed the menu.
        this.$prefs.expandPostsMenu = false
      }
      this.postsMenuOpen = !this.postsMenuOpen
    },
    routeWithAccountParams(baseUrl) {
      if (
        this.$prefs.rememberSelectedAccounts &&
        this.$store.state.selectedSocialAccountIds.length
      ) {
        const selectedAccounts = this.$store.state.selectedSocialAccountIds

        const params = new URLSearchParams()
        selectedAccounts.forEach((id) => params.append('socialAccount', id))

        return `${baseUrl}?${params.toString()}`
      } else {
        return baseUrl
      }
    }
  },
  computed: {
    ...mapState(['profile']),
    ...mapGetters([
      'isLoggedIn',
      'plan',
      'connectedPlatforms',
      'isConnectedToNonRedditPlatform',
      'totalAccounts'
    ]),
    displayRedditFeatures() {
      return (
        this.connectedPlatforms.length === 0 ||
        this.connectedPlatforms.includes('reddit')
      )
    },
    accountsWithoutHistoryEnabled() {
      if (!this.profile) {
        return []
      } else {
        return this.profile.redditAccounts.filter(
          (account) => !account.hasHistoryEnabled
        )
      }
    },
    hasUnlimitedPosts() {
      if (!this.profile) {
        return false
      } else {
        return isUnlimited(this.profile.account.allowedMonthlyPosts)
      }
    },
    shouldShowUpgradePlan() {
      if (!this.profile) {
        return false
      }
      return (
        this.plan.monthlyPrice === 0.0 ||
        this.$store.getters.monthlyPostUsagePercentage >= 0.8
      )
    },
    steps() {
      if (this.profile && isPaidPlan(this.profile.account.plan)) {
        tourSteps = tourSteps.filter(
          (step) => step.target !== '[data-v-step="upgrade-account"]'
        )
      }
      return tourSteps
    },
    hasUnreadMessages() {
      return this.$store.getters.totalUnreadCount > 0
    },
    anyPostsSubMenusActive() {
      return (
        this.$route.path.startsWith('/scheduled') ||
        this.$route.path.startsWith('/history') ||
        this.$route.path.startsWith('/drafts') ||
        this.$route.path.startsWith('/campaigns') ||
        this.$route.path.includes('/import') ||
        this.$route.path.startsWith('/trash') ||
        this.$route.path.startsWith('/overdue')
      )
    }
  },
  watch: {
    '$route.path': {
      handler() {
        if (!this.$prefs.expandPostsMenu && !this.anyPostsSubMenusActive) {
          this.postsMenuOpen = false
        } else {
          this.postsMenuOpen = true
        }
      },
      immediate: true
    }
  }
}
